import React, { useEffect, useState } from 'react'
import { Link, withRouter } from 'react-router-dom'
import CloseIcon from '@material-ui/icons/Close';
import { Bracket, RoundProps, Seed, SeedItem, SeedTeam, RenderSeedProps } from 'react-brackets';
import { CircularProgress, Button } from '@material-ui/core'
import jQuery from 'jquery'


function Tournament(props) {
	const baseURL = process.env.PUBLIC_URL;
	const close = ()=>{
		props.history.replace(baseURL+'/dashboard')
	}




	/* Use Effect -------------------------------------------- */	

	useEffect (()=> {

	},[]);
	
		if(1 != 0){
			return (
				<main>
					<header className="header-aux">
						<div></div>
						<h3>Torneo</h3>
						<CloseIcon onClick={close} />
					</header>
					<section className="container-plain">
						<div id="demo">Próximamente</div>
					
					</section>
				</main>
			)
	} else {
		return (
			<div className="loading">
				<CircularProgress />
			</div>
			)
	}
}

export default withRouter(Tournament)